import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import accept1978e4 from './accept'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
export const accept = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: accept.url(options),
    method: 'get',
})

accept.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/invitations/accept',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
accept.url = (options?: RouteQueryOptions) => {
    return accept.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
accept.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: accept.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
accept.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: accept.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
const acceptForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: accept.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
acceptForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: accept.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::accept
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:21
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
acceptForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: accept.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

accept.form = acceptForm

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
export const invalid = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: invalid.url(options),
    method: 'get',
})

invalid.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/invitations/invalid',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
invalid.url = (options?: RouteQueryOptions) => {
    return invalid.definition.url + queryParams(options)
}

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
invalid.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: invalid.url(options),
    method: 'get',
})

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
invalid.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: invalid.url(options),
    method: 'head',
})

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
const invalidForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: invalid.url(options),
    method: 'get',
})

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
invalidForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: invalid.url(options),
    method: 'get',
})

/**
* @see routes/org.php:68
* @route 'https://org.proexpert.app/org/invitations/invalid'
*/
invalidForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: invalid.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

invalid.form = invalidForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:25
* @route 'https://org.proexpert.app/org/invitations'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/invitations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:25
* @route 'https://org.proexpert.app/org/invitations'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:25
* @route 'https://org.proexpert.app/org/invitations'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:25
* @route 'https://org.proexpert.app/org/invitations'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:25
* @route 'https://org.proexpert.app/org/invitations'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::resend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:55
* @route 'https://org.proexpert.app/org/invitations/{staffUser}/resend'
*/
export const resend = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resend.url(args, options),
    method: 'post',
})

resend.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/invitations/{staffUser}/resend',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::resend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:55
* @route 'https://org.proexpert.app/org/invitations/{staffUser}/resend'
*/
resend.url = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { staffUser: args }
    }

    if (Array.isArray(args)) {
        args = {
            staffUser: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        staffUser: args.staffUser,
    }

    return resend.definition.url
            .replace('{staffUser}', parsedArgs.staffUser.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::resend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:55
* @route 'https://org.proexpert.app/org/invitations/{staffUser}/resend'
*/
resend.post = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resend.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::resend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:55
* @route 'https://org.proexpert.app/org/invitations/{staffUser}/resend'
*/
const resendForm = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resend.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::resend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:55
* @route 'https://org.proexpert.app/org/invitations/{staffUser}/resend'
*/
resendForm.post = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resend.url(args, options),
    method: 'post',
})

resend.form = resendForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::revoke
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:110
* @route 'https://org.proexpert.app/org/invitations/{invitation}/revoke'
*/
export const revoke = (args: { invitation: string | number } | [invitation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: revoke.url(args, options),
    method: 'post',
})

revoke.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/invitations/{invitation}/revoke',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::revoke
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:110
* @route 'https://org.proexpert.app/org/invitations/{invitation}/revoke'
*/
revoke.url = (args: { invitation: string | number } | [invitation: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invitation: args }
    }

    if (Array.isArray(args)) {
        args = {
            invitation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invitation: args.invitation,
    }

    return revoke.definition.url
            .replace('{invitation}', parsedArgs.invitation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::revoke
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:110
* @route 'https://org.proexpert.app/org/invitations/{invitation}/revoke'
*/
revoke.post = (args: { invitation: string | number } | [invitation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: revoke.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::revoke
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:110
* @route 'https://org.proexpert.app/org/invitations/{invitation}/revoke'
*/
const revokeForm = (args: { invitation: string | number } | [invitation: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revoke.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationController::revoke
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationController.php:110
* @route 'https://org.proexpert.app/org/invitations/{invitation}/revoke'
*/
revokeForm.post = (args: { invitation: string | number } | [invitation: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revoke.url(args, options),
    method: 'post',
})

revoke.form = revokeForm

const invitations = {
    accept: Object.assign(accept, accept1978e4),
    invalid: Object.assign(invalid, invalid),
    store: Object.assign(store, store),
    resend: Object.assign(resend, resend),
    revoke: Object.assign(revoke, revoke),
}

export default invitations